import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import css from './side-menu-new-badge.css';


export const NewBadge = (): React.ReactElement => {
  const {t} = useLabelTranslation();
  return (
    <span className={css.newBadge} id="side-nav-ai-agents-new-label">
      {t('New', 'New')}
    </span>
  );
};
